import find from './find';
import all from './all';
import fetchSuggestions from './fetchSuggestions';

export default {
  find,
  all,
  fetchSuggestions,
};



// WEBPACK FOOTER //
// ./src/app/services/postal/index.js